import { doc, getDoc } from "firebase/firestore";
import { auth, db, functions } from "../../firebase/firebase";
import { nameofPermissionSchemaCollection, PermissionSchema, PermissionView, Roles } from "../Types/PermissionSchema";
import { httpsCallable } from "firebase/functions";


export async function getPermission(): Promise<PermissionView | undefined> {
    if (auth.currentUser == null) {
        return undefined;
    }
    const currentUser = auth.currentUser;

    const permissionRef = doc(db, nameofPermissionSchemaCollection, currentUser.uid);

    const permission = await getDoc(permissionRef);
    
    if (permission.exists()) {
        return {
            Id: permission.id,
            Role: permission.data().Role,
        } as PermissionView;
    }

    return undefined;
}

export async function getPermissionById(userId: string): Promise<PermissionView | undefined> {
    const permissionRef = doc(db, nameofPermissionSchemaCollection, userId);

    const permission = await getDoc(permissionRef);

    if (permission.exists()) {
        return {
            Id: permission.id,
            Role: permission.data().Role,
        } as PermissionView;
    }

    return undefined;
}

export async function createPermission(Role?: Roles): Promise<void> {
    if (auth.currentUser == null) {
        throw new Error("No user is currently signed in.");
    }

    const createAccountFunction = httpsCallable(functions, "createPermission");

    await createAccountFunction({
        Role: Role ?? Roles.User
    }).catch((error) => {
        throw new Error(error);
    });
}

export async function updatePermission(updatedPermission: PermissionSchema): Promise<void> {
    if (auth.currentUser == null) {
        throw new Error("No user is currently signed in.");
    }

    const updateAccountFunction = httpsCallable(functions, "updatePermission");

    await updateAccountFunction({
        ...updatedPermission
    }).catch((error) => {
        throw new Error(error);
    });
}